import {ThunkDispatch, UnknownAction} from '@reduxjs/toolkit';
import {showNotification} from 'platform/components';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {messagingApi} from '../..';
import {AppSyncDataPayload, SubscribeToNotificationsApiArg} from '../types';

export const handleIncomingData =
  (
    dispatch: ThunkDispatch<any, any, UnknownAction>,
    onData: (notification: SubscribeToNotificationsApiArg) => void
  ) =>
  (payload: AppSyncDataPayload) => {
    const backgroundNotificationId = payload.data.onSendNotification.backgroundNotificationId;
    const toastNotificationId = payload.data.onSendNotification.toastNotificationId;

    if (isNotNil(backgroundNotificationId)) {
      dispatch(
        messagingApi.endpoints.getSentBackgroundNotification.initiate({
          id: backgroundNotificationId,
        })
      )
        .unwrap()
        .then((data) => onData({variant: 'background', ...data}))
        .catch(() => {
          showNotification.error();
        });
    }

    if (isNotNil(toastNotificationId)) {
      dispatch(
        messagingApi.endpoints.getSentToastNotification.initiate({
          id: toastNotificationId,
        })
      )
        .unwrap()
        .then((data) => {
          showNotification.info(i18n.t('general.labels.newNotificationReceived'));
          onData({variant: 'toast', ...data});
        })
        .catch(() => {
          showNotification.error();
        });
    }
  };
